import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import AuthService from "src/components/AuthService";
import { isNotEmptyObject } from "src/components/library/helpers";

const auth = new AuthService();

const initialState = {
    user: {},
    employee: {},
    operator: {},
    group: localStorage.getItem("group_token"),
    selectedUserTypeDisplay: "",
    tokenUser: { ...auth.getProfile() },
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser(state, action) {
            state.user = action.payload;
        },
        setGroup(state, action) {
            state.group = action.payload;
        },
        setTokenUser(state) {
            state.tokenUser = { ...auth.getProfile() };
        },
        resetUser(state) {
            state.user = {};
            state.employee = {};
            state.operator = {};
            state.tokenUser = {};
            state.group = localStorage.getItem("group_token");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPortalUser.pending, (state) => {
                state.user = {};
                state.operator = {};
                state.employee = {};
            })
            .addCase(fetchPortalUser.fulfilled, (state, action) => {
                state.operator = action.payload?.employee?.device_user[0] || {};
                state.employee = action.payload?.employee || {};
                state.user = action.payload || {};
            })
            .addCase(fetchPortalUser.rejected, (state, action) => {
                state.user = {};
            })
            .addCase(fetchDeviceOperator.pending, (state) => {
                state.operator = {};
            })
            .addCase(fetchDeviceOperator.fulfilled, (state, action) => {
                state.operator = action.payload[0];
            })
            .addCase(fetchDeviceOperator.rejected, (state, action) => {
                state.operator = {};
            });
    }
});

export const fetchPortalUser = createAsyncThunk("user/fetchPortalUser", async (userId) => {
    const response = await auth.fetch(`/api/portal-user/${userId}`);
    return response;
});

export const selectUserForSettings = createSelector((state) => state.user.user, (user) => {
    return isNotEmptyObject(user) ? {
        id: user.id,
        username: user.username,
    } : {};
});

export const selectEmployeeForSettings = createSelector((state) => state.user, (user) => {
    const employee = user.employee;
    return isNotEmptyObject(employee) ? {
        id: employee.id,
        full_name: employee.full_name,
        email_address: employee.email_address,
        phone: employee.phone,
        group: user.group,
        customer_id: employee.customer.id,
    } : {};
})

export const selectOperatorForSettings = createSelector((state) => state.user.operator, (operator) => {
    return isNotEmptyObject(operator) ? {
        id: operator.id,
        pin: operator.pin,
        notify_complete: operator.notify_complete,
        notify_error: operator.notify_error,
    } : {};
});

export const fetchDeviceOperator = createAsyncThunk("user/fetchDeviceOperator", async (employeeId) => {
    const response = await auth.fetch(`/api/device-operator/?employee_id=${employeeId}`);
    return response;
});

export const updatePortalUser = createAsyncThunk("user/updatePortalUser", async ({ userId, user }) => {
    const response = await auth.fetch(`/api/portal-user/${userId}`, {
        method: "PATCH",
        body: JSON.stringify(user),
    });
    return response;
})

export const updateEmployee = createAsyncThunk("user/updateEmployee", async ({ employeeId, employee }) => {
    const response = await auth.fetch(`/api/employee/${employeeId}`, {
        method: "PATCH",
        body: JSON.stringify(employee),
    });
    return response;
});

export const updateOperator = createAsyncThunk("user/updateOperator", async ({ operatorId, operator }) => {
    const response = await auth.fetch(`/api/device-operator/${operatorId}`, {
        method: "PATCH",
        body: JSON.stringify(operator),
    });
    return response;
});

export const { setUser, setGroup, resetUser, setTokenUser } = userSlice.actions;

export default userSlice.reducer;
